import { CwtApiEntity, CwtCrudContract, CwtModel, CwtProp } from "@cawita/core-front/api";
import { formatName } from "@shared/utils/string.utils";
import { UploadFile } from "../common";
import { Role } from "./role.model";
import type { LockType } from "./user-lock.model";

const UserSearchMapper = (s) => ({
    or: [
        { firstName: { regexp: s } },
        { lastName: { regexp: s } },
        { email: { regexp: s } },
    ]
})

@CwtModel({ name: 'user' })
@CwtCrudContract({ path: '/user', searchMapper: UserSearchMapper })
export class User extends CwtApiEntity {
    @CwtProp() firstName?: string;
    @CwtProp() lastName?: string;
    @CwtProp() email?: string;
    @CwtProp() emailValid?: boolean;
    @CwtProp() accessType?: string;
    @CwtProp() lockType: LockType;
    @CwtProp({ ref: Role }) role?: Role;
    @CwtProp({ ref: UploadFile }) picture: UploadFile;

    public get name() { return formatName(this.firstName, this.lastName); }
}